import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ActivityLoggerService } from 'src/app/_shared/service/activity-logger.service';
import { UserState } from 'src/app/_shared/state/user.state';
import { PortfolioService } from 'src/app/portfolio/service/portfolio.service';
import constants from 'src/constant.json';
import { MyHomeService } from '../../service/my-home.service';
import { MyHomeState } from '../../state/my-home.state';

@Component({
  selector: 'app-contact-agent-info',
  templateUrl: './contact-agent-info.component.html',
  styleUrls: ['./contact-agent-info.component.scss'],
})
export class ContactAgentInfoComponent implements OnInit {
  constructor(
    private myHomeService: MyHomeService,
    public myHomeState: MyHomeState,
    public matDialog: MatDialog,
    public portfolioService: PortfolioService,
    public userState: UserState,
    public activityLoggerService: ActivityLoggerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  connectedAgent: any;
  isDashboard: any;
  suggestedMessages: string[] = [
    "I'm interested in selling this property",
    'I wish to get more market insights about this property',
  ];

  dashboardMessages: string[] = [
    "Hello! I'd like to reach out and connect with you",
    'Hi there! I have a quick question and would love to connect.',
  ];

  selectedMessageValue: any;
  noMessageFound: boolean;
  isLoadingAgentDetails: any;
  isLoadingSubmitButton: any;
  defaultProfileImage = constants.userAvatar;
  ngOnInit(): void {
    this.getContactInfo();
    this.isDashboard = this.data?.source == 'dashboard';
  }
  onTypeMessage() {
    this.noMessageFound = false;
  }
  getContactInfo() {
    this.myHomeService
      .contactAgentInfo()
      .pipe()
      .subscribe((res: any) => {
        this.isLoadingAgentDetails = res.isLoading;
        this.connectedAgent = res?.result;
      });
  }

  selectedMessage(message) {
    this.selectedMessageValue = message;
    this.noMessageFound = false;
  }
  notifyAgent() {
    if (!this.selectedMessageValue) {
      this.noMessageFound = true;
      return;
    }

    if (this.data?.source == 'dashboard') {
      const contactFormObject = {
        name: this.userState.userDetails.user_profile.firstName,
        email: this.userState.userDetails.user_profile.email,
        phone: this.userState.userDetails.user_profile.contact,
        //  agentId: this.connectedAgent.id,
        source: 'dashboard',
        message: this.selectedMessageValue,
      };
      this.portfolioService
        .sendContactInfo(this.connectedAgent.id, contactFormObject)
        .pipe()
        .subscribe(({ isLoading }) => {
          this.isLoadingSubmitButton = isLoading;
          if (!isLoading) this.matDialog.closeAll();
          this.logUserActivity(constants.LOGGER.general.category, constants.LOGGER.general.action.contactAgent.key);
        });

      return;
    }

    this.myHomeService
      .notifyContactAgent({
        homeId: this.myHomeState.activeHomeValue.id,
        agentId: this.connectedAgent.id,
        message: this.selectedMessageValue,
      })
      .pipe()
      .subscribe((res: any) => { });
    this.matDialog.closeAll();
  }

  logUserActivity(category, action) {
    let loggerParams = {
      category: category,
      action: action,
    };
    let inputData = {};
    this.activityLoggerService.logActivity(loggerParams, inputData);
  }
}
